<style lang="scss" src='./TaskDetails.scss' scoped ></style>
<template src="./TaskDetails.html"></template>

<script>
import { mapMutations, mapActions } from 'vuex';
import { getHoles, getZones, getUsers, getUsersCustomer, saveTask, updateTask, saveTaskComment, DeleteTaskComment, getActivities } from '@/api/index';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { omit, cloneDeep } from 'lodash';
import { required } from 'vee-validate/dist/rules';
import TaskActivity from './activity/TaskActivity';
import MapRedFlag from '@/assets/img/ic/ic_flag_red.png';
import Multiselect from 'vue-multiselect'

extend('required', required);

export default {
  name: 'TaskDetails',
  components: {
    ValidationProvider,
    ValidationObserver,
    TaskActivity,
    Multiselect,
  },
  props: {},
  data() {
    return ({
      holes: [],
      zones: [],
      activities: [],
      users: [],
      comment: '',
      map: null,
      google: null,
      mapMarker: null,
      task: {},
      assigned_to: [],
      loading: {
        creatingTask: false,
        creatingComment: false,
        map: true,
      },
      updatingTask: false,
      can_update: false,
    });
  },
  computed: {
    zonesFiltered: function fnZonesFiltered() {
      if (this.zones && this.zones.length) {
        if (this.task.hole_id == 'all') {
          return this.zones;
        } else if (this.task.hole_id == 'other') {
          return this.zones.filter((zone) => !zone.hole_linked);
        } else if (this.task.hole_id > 0) {
          return this.zones.filter((zone) => zone.hole_linked);
        }
      }
      return [];
    },
    course() {
        return this.$store.state.course;
    },
    orderedActivities() {
      if (this.activities && this.activities.length > 0) {
        let getName = this.getActivityName;
        return this.activities.sort(function(a, b) {
          var nameA = getName(a).toUpperCase(); // ignore upper and lowercase
          var nameB = getName(b).toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
      }
    },
    validCoordinates(){
      if(this.task.longitude && this.task.latitude && this.G_validateLatLong(this.task.latitude, this.task.longitude)){
        return true
      }
      return false
    }
  },

  methods: {

    getActivityName(activity) {
      if(activity.i18n.length > 0){
        let text = activity.i18n.find((item)=>{
          if(item.language == this.$i18n.locale){
            return item
          }    
        })

        if(text){
          return text.i18n
        }else{
          return activity.name
        }
      }else{
        return activity.name
      }
    },

    openModal(task) {
      this.comment = '';
      this.$refs['modal-task-details'].show();
      this.task = task ? task : this.G_getTaskBean({});
      this.assigned_to = this.task.users;
      this.updatingTask = (task && task.task_id);
    },

    closeModal(){
      this.$refs['modal-task-details'].hide();
    },

    async onModalShown() {
      await this.initMap({ lat: 0, lng: 0 });
      const mapIcon = this.task.alert_id ? MapRedFlag : null;
      if (this.task.location_attached) {
          this.G_addMarkerToMap({lat: this.task.latitude, lng: this.task.longitude}, mapIcon, this.setTaskLocation);
      }
      if (!this.task.hole_id && this.task.zone_id && this.task.all_holes){
        this.task.hole_id = 'all';
      }else if (!this.task.hole_id && this.task.zone_id){
        this.task.hole_id = 'other';
      }
      this.loading.map = false;
    },

    async initMap({ lat = 0, lng = 0 }) {
      const mapOptions = {
        mapId: 'mapTaskDetails',
        zoom: 0,
        center: { lat, lng },
        controlOptions: {
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
        },
      };

      this.map = await this.G_initMap(mapOptions);
      this.google = this.consts.Google.MAP;
    },

    useCurrentLocation() {
      if (this.task.location_attached) {
        this.G_findCurrentLocation(this.setTaskLocation);
      } else {
        this.setTaskLocation({ lat: null, lng: null });
      }
    },

    setTaskLocation({ lat, lng }) {
      this.task.latitude = lat;
      this.task.longitude = lng;
    },

    loadHoles() {
      getHoles().then((res) => {
        if (res.holes) {
          this.holes = res.holes;
        }
      });
    },

    loadZones() {
      getZones().then((res) => {
        if (res.zones) {
          this.zones = res.zones; 
        }
      });
    },

    loadActivities() {
      getActivities().then((res) => {
        if (res.activities) {
          this.activities = res.activities; 
        }
      });
    },

    loadUsers() {
      getUsers(null).then((res) => {
        if (res.users) {
          this.users = res.users; 
        }
      });
    },

    loadUsersCustomer() {
      getUsersCustomer(null).then((res) => {
        if (res.users) {
          this.users = res.users; 
        }
      });
    },

    onLocationChange() {
      this.task.zone_id = null;
    },

    async addComment() {
      if (this.comment) {
        this.loading.creatingComment = true;
        let commentObj = {
            comment: this.comment,
            type: this.consts.TaskActivityType.COMMENT,
            time_created: new Date(),
            user: this.$store.state.user,
        };
        if (this.updatingTask) {
          commentObj = await this.createTaskComment(commentObj, this.task.task_id);
          this.pushTaskActivity({ taskActivity: cloneDeep(commentObj), task: cloneDeep(this.task) });
        }
        this.task.activities.unshift(commentObj);
        
        this.comment = '';
        this.loading.creatingComment = false;
      }
    },

    async saveOrUpdateTask() {
      const validForm = await this.$refs.validator.validate().then((v) => v);
      if (validForm) {
        this.loading.creatingTask = true;
        this.task.all_holes = false;
        const task = omit(this.task, ['activities', 'assignee', 'status', 'time_created', 'time_updated', 'task_id', 'course_id',
          'creator_id', 'orden', 'deleted', 'activity', 'users']);
        
        if(task.hole_id == 'all'){
          task.all_holes = true;
        }
        
        if( (this.$store.state.course.facility_type && this.$store.state.course.facility_type.is_golf_course) || !this.$store.state.course.facility_type ){
          task.hole_id = (task.hole_id == 'all' || task.hole_id == 'other') ? null : task.hole_id;
        }else{
          task.zone_id = null
          task.hole_id = null
        }
        
        task.course_id = this.$store.state.course.course_id;
        
        let taskSaved = null;
        
        if (this.assigned_to && this.assigned_to.length > 0){
          task.users = [];
          this.assigned_to.forEach(user => {
            task.users.push(user.user_id);
          });
        }

        if (this.updatingTask) {
          taskSaved = await updateTask(task, this.task.task_id, true);
        } else {
          taskSaved = await this.saveTask(task);
        }
        this.assigned_to = [];
        this.pushTask(taskSaved);
        this.loading.creatingTask = false;
        this.closeModal();

      }
    },

    async saveTask(task) {
      let taskSaved = await saveTask(task);
      if (this.task.activities.length) {
          let activitiesSaved = [];
          const commentsToSave = this.task.activities.filter((activity) => !activity.activity_id).reverse();
          for (let index = 0; index < commentsToSave.length; index++) {
            const activitySaved = await this.createTaskComment(commentsToSave[index], taskSaved.task_id);
            activitiesSaved.unshift(activitySaved);
          }
            
          if (activitiesSaved.length) {
            taskSaved.activities.unshift(...activitiesSaved);
          }
      }
      return taskSaved;
    },

    async createTaskComment(comment, task_id) {
      const activityData = omit(comment, ['time_created', 'user']);
      activityData.task_id = task_id;
      return await saveTaskComment(activityData);
    },

    onDeleteComment(activity, index) {
      if (activity.activity_id) {
        this.G_Alert({ type: this.consts.DialogType.CONFIRM, 
                      style: this.consts.Style.INFO, message: this.$t('tasks.dywDeleteTask'),
                      backdropClose: true, fnOk: async () => {
                        await DeleteTaskComment(activity.activity_id);
                        this.task.activities.splice(index, 1);
                        this.pushTask(cloneDeep(this.task));
                      }});
      } else {
        this.task.activities.splice(index, 1);
      }
      

    },

    // Call dashboard store to add or update the current task
    ...mapMutations('TaskBoard', ['pushTaskActivity']),
	...mapActions('TaskBoard', ['pushTask']),
  },

  beforeCreate() {},

  created() {},

  mounted() {
    if (process.env.VUE_APP_SENTRY_ENV == "production") {
      this.$analytics.setCurrentScreen("Web Tasks");
      this.$analytics.logEvent("web_tasks");
    }

    this.loadHoles();
    this.loadZones();
    this.loadActivities();

    if (this.$store.state.user.user_type.type_id == this.consts.UserType.ADMIN ||
        this.$store.state.user.user_type.type_id == this.consts.UserType.OPERATIONS){
      this.loadUsers();
    } else {
      this.loadUsersCustomer();
    }

    let menuPolicy = this.$store.state.menuPolicy.find((policy) => policy.vue_component == 'TaskBoard');

    if(menuPolicy && menuPolicy.policy){
      this.can_update = menuPolicy.policy.can_update;
    }
  },

  beforeDestroy() {},

};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

.task-multiselect .multiselect__placeholder {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1;
  color: #495057;
}

.task-multiselect .multiselect__tags{
  min-height: 38px;
  border-color: rgb(206, 212, 218);
}

.task-multiselect .multiselect__select:before{
  color: #343a40 !important;
  border-color: #343a40 transparent transparent;
}

</style>